import {
  AddressInfo,
  defaultAddress,
  Modification,
  RolesPossibleValues,
  RoleTranslationKeys,
} from '../subtypes'
import { DocumentsList } from '../subtypes/documentType/documentType'

type Functions = Array<string>

type Connection = {
  applicationName: Omit<RoleTranslationKeys, 'none' | 'buyer' | 'seller'> | ''
  firstConnection: string
  lastConnection: string
}

type ContactWithoutAddress = {
  id: string
  firstName: string
  lastName: string
  phoneNumber: string
  signInName: string
  email: string
  emails: string[]
  status: boolean
  assignedEntityId: string
  associatedEntities: string[]
  associatedEntitiesComplete: string[]
  roles: RolesPossibleValues
  functions: Functions
  representativeOf: Array<string>
  sendWelcomeEmail: boolean
  mailConsent: boolean
  smsConsent: boolean
  idCardFileStorageId: string
  createdBy: string
  createdOn: string
  createdDateTime?: string
  connections: Array<Connection>
  referralSource: string
  documentsList: DocumentsList
  modifications?: { [key: string]: Modification | null }
  lastUpdatedAt?: string
  preferedLanguage: number
}

type Contact = ContactWithoutAddress & {
  location: Array<AddressInfo>
}

type ContactFlattened = ContactWithoutAddress & AddressInfo

type BeforeCreateOmittedKeys = 'id' | 'status'

type ContactBeforeCreateWithoutAddress = Omit<ContactWithoutAddress, BeforeCreateOmittedKeys>
type ContactBeforeCreate = Omit<Contact, BeforeCreateOmittedKeys>
type ContactBeforeCreateFlattened = Omit<ContactFlattened, BeforeCreateOmittedKeys>

const defaultContactBeforeCreateWithoutAddress: ContactBeforeCreateWithoutAddress = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  signInName: '',
  email: '',
  emails: [],
  assignedEntityId: '',
  associatedEntitiesComplete: [],
  associatedEntities: [],
  roles: 0,
  functions: [],
  representativeOf: [],
  mailConsent: false,
  smsConsent: false,
  sendWelcomeEmail: false,
  idCardFileStorageId: '',
  createdBy: '',
  createdOn: '',
  createdDateTime: '',
  connections: [],
  referralSource: '',
  documentsList: [],
  preferedLanguage: 0,
}

const defaultContactBeforeCreate: ContactBeforeCreate = {
  ...defaultContactBeforeCreateWithoutAddress,
  // location
  location: [{ ...defaultAddress }],
}

const defaultContactBeforeCreateFlattened: ContactBeforeCreateFlattened = {
  ...defaultContactBeforeCreateWithoutAddress,
  // location
  ...defaultAddress,
}

const defaultContact: Contact = {
  id: '',
  status: true,
  ...defaultContactBeforeCreate,
}

const defaultContactFlattened: ContactFlattened = {
  id: '',
  status: true,
  ...defaultContactBeforeCreateFlattened,
}

export type {
  Functions,
  Contact,
  ContactFlattened,
  ContactBeforeCreate,
  ContactBeforeCreateFlattened,
  Connection,
}

export {
  defaultContact,
  defaultContactFlattened,
  defaultContactBeforeCreate,
  defaultContactBeforeCreateFlattened,
}
